import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import CommonReducer from '../reducers/Common';
import TaskReducer from '../reducers/Task';
import OrganizationReducer from '../reducers/Organization';
import OTPReducer from '../reducers/OTP';

const persistConfig = {
    key: 'root',
    storage,
};

export const reducers = persistCombineReducers(persistConfig, {
    common: CommonReducer,
    task: TaskReducer,
    organization: OrganizationReducer,
    otp: OTPReducer,
});

const middleware = applyMiddleware(thunk);

export const store = createStore(reducers, undefined, compose(middleware));

export const persistor = persistStore(store, compose(middleware));
